import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL    = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON   = process.env.REACT_APP_SUPABASE_ANON_KEY;
const AUTH_WORKER_URL = "https://healhub-auth.apihealhubspace.workers.dev";

let currentToken = null;
let refreshTimer = null;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: {
    persistSession:     false,
    autoRefreshToken:   false,
    detectSessionInUrl: false,
  },
  global: {
    fetch: async (url, options = {}) => {
      const h = new Headers(options.headers || {});
      h.set("apikey", SUPABASE_ANON);
      h.set("Authorization", `Bearer ${currentToken || SUPABASE_ANON}`);
      return fetch(url, { ...options, headers: h });
    },
  },
});

async function fetchSupabaseToken(firebaseUser) {
  try {
    const idToken = await firebaseUser.getIdToken();
    const res = await fetch(AUTH_WORKER_URL, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ idToken }),
    });
    if (!res.ok) throw new Error(`Worker returned ${res.status}`);
    const data = await res.json();
    return data.token;
  } catch (err) {
    console.error("[supabase] fetchSupabaseToken failed:", err.message);
    return null;
  }
}

export async function setSupabaseAuth(firebaseUser) {
  if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null; }

  if (!firebaseUser) {
    currentToken = null;
    return;
  }

  try {
    const token = await fetchSupabaseToken(firebaseUser);
    if (token) {
      currentToken = token;
      refreshTimer = setTimeout(async () => {
        const newToken = await fetchSupabaseToken(firebaseUser);
        if (newToken) currentToken = newToken;
      }, 55 * 60 * 1000);
    }
  } catch (err) {
    console.error("[supabase] setSupabaseAuth failed:", err);
  }
}